import { withInstall } from '@jdesign-vue/utils'
import TreeSelect from './src/tree-select.vue'

export const JdTreeSelect = withInstall(TreeSelect)
export default JdTreeSelect

